import { render, staticRenderFns } from "./QuiSommesNous.vue?vue&type=template&id=ca8be634&scoped=true&"
import script from "./QuiSommesNous.vue?vue&type=script&lang=js&"
export * from "./QuiSommesNous.vue?vue&type=script&lang=js&"
import style0 from "./QuiSommesNous.vue?vue&type=style&index=0&id=ca8be634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8be634",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
